module.exports = __webpack_public_path__ + "static/img/developing.aa73838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developing.png
// module id = MNTA
// module chunks = 1